define('views/modules/calendar/animated-session/exercise/weight/weight-set',[
    // Libs
    'jquery', 'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/weight/weight-set.html',
    // events
    "services/events/animated-session-events",

], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // services
    Viewport,
    // templates
    TWeightExerciseSet,
    AnimationEvents
) {

    var VWeightExerciseSet = Backbone.Epoxy.View.extend({
        template: TWeightExerciseSet,

        events: {
            "click input": "onExerciseInputClick",
            "click .fa-floppy-o": "onLoadOrRepsChange",
            "keydown input[type='number'], .rest-col input": 'onKeyDown'
        },

        regions: {
            reps: ".reps-col",
            load: ".load-col",
            rest: ".rest-col",
            loadInput: "input[name='load']",
            validation: ".set-validation",
            warning: ".fa-floppy-o",
        },

        /**
         * Provide a "first" option to add the week and sets columns.
         */
        initialize: function(opt) {
            this.options = opt || {};
            this._invalid = false;
            this.modelCopy = this.model.clone();

            this.bindingSources = {
                week: this.options.week,
                options: new Backbone.Model({
                    multiEnabled: this.options.week.hasMultiRep()
                })
            };

            this.listenTo(this.model, {
                "invalid": this.onInvalid,
                "change": this.onChange,
                "remove": this.remove,
            });
            this.listenTo(this.options.week, {
                "change:multiEnabled": this.onMultiSetToggle,
            });

        },
        render: function() {
            this.setElement(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.generateZones()
                .applyBindings();

            this.setConvertedLoadValue();

            return this;
        },

        setConvertedLoadValue: function() {
            this.zone.$loadInput.val(this.model.get('convertedLoadValue'));
        },

        resetInvalid: function() {
            if (this._invalid) {
                this._invalid = false;
                this.zone.$validation.removeClass("invalid");
            }
        },

        ////////////
        // events //
        ////////////
        onInvalid: function(model, error, options) {
            this._invalid = true;
            _.each(error, function(errors, field) {
                var $elem = this.zone['$' + field];
                if ($elem) $elem.addClass("invalid");
            }, this);
        },

        onKeyDown: function(e) {
            var accepted_values = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "backspace", "tab", "."];

            if (!accepted_values.includes(e.key.toLowerCase())) {
                e.preventDefault();
            }
        },

        onLoadOrRepsChange: function(e) {
            e.preventDefault();
            // Save without closing the panel
            AnimationEvents.saveRepsOrLoads();
            this.zone.$warning.addClass('hidden');
        },

        onChange: function(model, options) {
            this.resetInvalid();
            model.isValid();
            if (!Viewport.isMobile()) {
                this.$('.fa-floppy-o').tooltip();
            }
            if (this.options.warningIcon) {
                var $elem = this.zone.$warning;
                if (!_.isEqual(this.modelCopy.attributes, model.attributes)) {
                    if ($elem) $elem.removeClass("hidden");
                } else {
                    if ($elem) $elem.addClass("hidden");
                }
            }

        },
        onMultiSetToggle: function(model, value, options) {
            this.bindingSources.options.set({ multiEnabled: value });
        },

        onExerciseInputClick: function(e) {
            e.currentTarget.select();
        },

    });

    return VWeightExerciseSet;

});

